import Typography from "@mui/material/Typography";
import {Col, Row} from "reactstrap";
import {CircularProgress} from "@mui/material";
import {FormattedMessage, useIntl} from "react-intl";

export default function VatiaCheckoutSummary(props)
{
    const formatter = new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: 'CHF',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const intl = useIntl()

    let monthText = <span> / <FormattedMessage id={ 'abo.new.text.month' } defaultMessage={ 'Monat'} /></span>;

    return (
        <>
            <Row>
                <Col lg={4}>
                    <img style={{width:170, maxWidth:600}} src="/img/cbm_abo3.png"/>
                </Col>
                <Col lg={8} style={{marginTop:14, textAlign:"left", paddingRight:62, paddingLeft:30}}>
                    <Typography sx={{ fontSize: 12, paddingBottom: 0, }} color="text.secondary" gutterBottom>
                        <FormattedMessage id={ 'abo.new.summary.top.title' } defaultMessage={ 'Dr. Brauwolf Abo'} />
                    </Typography>
                    <Typography sx={{ fontSize: 18, fontWeight: 600, }} color="text.secondary">
                        {props.planTitle}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: 14, }} color="text.secondary" gutterBottom>
                        {props.timeframeTitle}
                    </Typography>
                </Col>
            </Row>
            {/*{props.firstName != null && props.firstName != "" ? <>*/}
            {/*    <hr style={{borderTop: "1px solid #B2BEB5", maxWidth: "80%"}}/>*/}
            {/*    <Row style={{paddingLeft:"10%", paddingRight:"10%"}}>*/}
            {/*        <Col lg={4} style={{textAlign: "left"}}>*/}
            {/*            Lieferadresse*/}
            {/*        </Col>*/}
            {/*        <Col lg={8} style={{textAlign: "left"}}>*/}
            {/*            {props.firstName} {props.lastName}<br/>*/}
            {/*            {props.line1}<br/>*/}
            {/*            {props.line2 != null && props.line2 != "" ? <>{props.line2}<br/></> : null}*/}
            {/*            {props.postalcode} {props.city}<br/>*/}
            {/*            {props.country}*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*    </> : <></>}*/}
            <hr style={{borderTop: "1px solid #B2BEB5", maxWidth: "80%"}}/>
            {/*<input placeholder={"Rabattcode"}/><button>anwenden</button>*/}
            <Row style={{paddingLeft:"10%", paddingRight:95, marginTop: -5}}>
                <form>
                    {props.couponInfo != null ?
                        <>
                            <Col lg={10} style={{textAlign: "left"}}>
                                <span style={{}}>Einmaliger Coupon {props.couponInfo.percentOff}%</span>
                            </Col>
                            <Col lg={2} style={{textAlign: "right"}}>
                                <button style={{backgroundColor:"#f19800",border:0,borderRadius:4,color:"#fff",padding:6,fontSize:12, fontWeight:400, marginTop: 0}}
                                        onClick={(e) => {e.preventDefault(); props.removePromoCode()}}>
                                    Entfernen
                                </button>
                            </Col>
                        </> :
                        props.couponSpinner ? <Row style={{textAlign:"center", fontSize:12, paddingLeft:35, paddingBottom:10}}><CircularProgress style={{color:"#495057"}} /></Row> :
                            props.timeframeMonths == 1 ?
                        <>
                            <Row style={{textAlign:"left", fontSize:12, paddingLeft:30, paddingBottom:10}}>
                                <span style={{color:"red"}}>{props.promoCodeInfo}</span>
                            </Row>
                            <Col lg={10} style={{textAlign: "left", paddingRight:0}}>
                                <input style={{width:"100%", fontSize:14, height: 35, padding:5, borderRadius: 5, border: "1px solid #CACACA", color: "#495057"}}
                                       value={props.promoCode} name={"promocode"} placeholder={intl.locale == "en" ? "Coupon code" : "Rabattcode"}
                                       onChange={props.handlePromoCode}/>
                            </Col>
                            <Col lg={2} style={{textAlign: "right"}}>
                                <button style={{backgroundColor: props.promoCode != null && props.promoCode != "" ? "#f19800" : "gray",border:0,borderRadius:5,
                                    color:"#fff",padding:6,marginTop:2, height:31, fontSize:12, fontWeight:400}} onClick={(e) => {e.preventDefault(); props.handlePromoCodeSubmit()}}
                                    disabled={props.promoCode == null || props.promoCode == ""}
                                >
                                    <FormattedMessage id={ 'abo.new.summary.button.apply' } defaultMessage={ 'Anwenden'} />
                                </button>
                            </Col>
                        </> : <div style={{textAlign:"left", paddingLeft:15}}>
                                <span style={{fontSize:12}}>
                                    <FormattedMessage id={ 'abo.new.summary.text.no.coupons' } defaultMessage={ 'Keine Coupons auf einmalige Zahlungen'} />
                                </span>
                            </div>}
                </form>
                {props.couponInfo != null ? <>
                <Col lg={12} style={{textAlign: "left", fontSize: 11}}>
                    {props.couponInfo != null ? <>
                        <FormattedMessage id={ 'abo.new.summary.text.mwst' } defaultMessage={ 'inkl. MwSt'} />
                        <FormattedMessage id={ 'abo.new.summary.text.save1' } defaultMessage={ 'Sie sparen '} />{formatter.format((props.couponInfo.percentOff*props.priceAmount)/100).replace(".00", ".-")}<FormattedMessage id={ 'abo.new.summary.text.save2' } defaultMessage={ ' auf die 1. Zahlung'} />
                    </> : null}
                </Col>
                {/*<Col lg={0} style={{textAlign: "right"}}>*/}
                    {/*{props.couponInfo != null ? <>-CHF {(props.couponInfo.percentOff*props.priceAmount)/100}.-</> : null}*/}
                {/*</Col>*/}
                </> : null}
            </Row>
            {/*<hr style={{borderTop: "1px solid #B2BEB5", maxWidth: "80%"}}/>*/}
            {/*<Row style={{paddingLeft:"10%", paddingRight:"10%"}}>*/}
            {/*    <Col lg={4} style={{textAlign: "left"}}>*/}
            {/*        /!*Zwischensumme<br/>*!/*/}
            {/*        Versand<br/>*/}
            {/*        {props.couponInfo != null ? <>Rabatt</> : null}*/}
            {/*    </Col>*/}
            {/*    <Col lg={8} style={{textAlign: "right"}}>*/}
            {/*        /!*CHF {priceAmount}.-{props.timeframeMonths == 1 ? <span> / Monat</span> : null}<br/>*!/*/}
            {/*        Kostenlos<br/>*/}
            {/*        {props.couponInfo != null ? <>-CHF {props.couponInfo.percentOff*priceAmount} im 1. Monat</> : null}*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <hr style={{borderTop: "1px solid #B2BEB5", maxWidth: "80%"}}/>
            <Row style={{paddingLeft:"10%", paddingRight:"10%"}}>
                <Col lg={4} style={{textAlign: "left", fontSize:16, lineHeight:0.7, marginTop:3}}>
                    <FormattedMessage id={ 'abo.new.summary.text.total' } defaultMessage={ 'Gesamt'} /><br/>
                    <span style={{fontSize:10}}><FormattedMessage id={ 'abo.new.summary.text.mwst' } defaultMessage={ 'inkl. MwSt'} /></span>
                </Col>
                <Col lg={8} style={{textAlign: "right"}}>
                    <span style={{fontSize:18, fontWeight:600}}>CHF {props.priceAmount}.-{props.timeframeMonths == 1 ? monthText : null}</span>
                </Col>
            </Row>
            {1==0 ? <Row style={{paddingLeft:"10%", paddingRight:"10%", paddingTop:60}}>
                <Col lg={12} style={{textAlign: "left", fontSize:12, lineHeight:0.7, marginTop:3, color: "rgba(45,45,45,.6)"}}>
                built with vatia
                </Col>
            </Row> : null}
        </>
    )
}